// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"809e40f0","732":"1b8ae1bb"}[chunkId] + ".chunk.js";
};